export type EnterHomeCreationType = 'app' | 'agent';
export const ENTER_HOME_PROMPT_SOURCE_ENTRY = 'enter_home_prompt' as const;

export interface PendingEnterHomePrompt {
    message: string;
    creationType: EnterHomeCreationType;
    planMode: boolean;
    model: string;
    journeyId?: string;
    sourceEntry?: typeof ENTER_HOME_PROMPT_SOURCE_ENTRY;
}

export interface SavePendingEnterHomePromptInput {
    message: string;
    creationType: EnterHomeCreationType;
    planMode?: boolean;
    model: string;
    journeyId: string;
}

export const PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS = {
    message: 'pending_chat_message',
    creationType: 'pending_chat_creation_type',
    planMode: 'pending_chat_plan_mode',
    model: 'pending_chat_model',
    journeyId: 'pending_chat_journey_id',
    sourceEntry: 'pending_chat_source_entry',
} as const;

export function savePendingEnterHomePrompt({
    message,
    creationType,
    planMode = false,
    model,
    journeyId,
}: SavePendingEnterHomePromptInput): void {
    const selectedModel = model || 'auto';
    sessionStorage.setItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.message, message);
    sessionStorage.setItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.creationType, creationType);
    sessionStorage.setItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.planMode, String(planMode));
    sessionStorage.setItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.model, selectedModel);
    sessionStorage.setItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.journeyId, journeyId);
    sessionStorage.setItem(
        PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.sourceEntry,
        ENTER_HOME_PROMPT_SOURCE_ENTRY
    );
}

export function readPendingEnterHomePrompt(): PendingEnterHomePrompt | null {
    const message = sessionStorage.getItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.message);
    if (!message) return null;

    const storedCreationType = sessionStorage.getItem(
        PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.creationType
    );
    const journeyId = sessionStorage.getItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.journeyId);
    const sourceEntry = sessionStorage.getItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.sourceEntry);

    return {
        message,
        // Payloads created before creationType existed always represented App creation.
        creationType: storedCreationType === 'agent' ? 'agent' : 'app',
        planMode:
            sessionStorage.getItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.planMode) === 'true',
        model: sessionStorage.getItem(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS.model) || 'auto',
        ...(journeyId ? { journeyId } : {}),
        ...(sourceEntry === ENTER_HOME_PROMPT_SOURCE_ENTRY
            ? { sourceEntry: ENTER_HOME_PROMPT_SOURCE_ENTRY }
            : {}),
    };
}

export function clearPendingEnterHomePrompt(): void {
    Object.values(PENDING_ENTER_HOME_PROMPT_STORAGE_KEYS).forEach((key) => {
        sessionStorage.removeItem(key);
    });
}
